
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class IceCrystalsEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config } = pc;
        const spacing = (300 + layerIndex * 100) / (config.parallaxPatternDensity || 1.0);
        const { x1, x2, y1, y2 } = this.getGridBounds(pc, spacing);
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 1 * scale;

        for (let x = x1; x <= x2; x += spacing) {
            for (let y = y1; y <= y2; y += spacing) {
                const offX = this.pseudoRandom(x) * spacing;
                const offY = this.pseudoRandom(y) * spacing;
                const size = (30 + this.pseudoRandom(x + y) * 50) * scale;
                
                const draw = () => {
                    ctx.save();
                    ctx.translate(x + offX, y + offY);
                    for (let i = 0; i < 6; i++) {
                        ctx.rotate(Math.PI / 3);
                        ctx.beginPath();
                        ctx.moveTo(0, 0);
                        ctx.lineTo(0, size);
                        // Sub-branches
                        ctx.moveTo(0, size * 0.5);
                        ctx.lineTo(size * 0.2, size * 0.7);
                        ctx.moveTo(0, size * 0.5);
                        ctx.lineTo(-size * 0.2, size * 0.7);
                        ctx.stroke();
                    }
                    ctx.restore();
                };
                draw();
                this.applyGlow(pc, draw);
            }
        }
    }
}
